<template>
  <v-menu :close-on-content-click="false" location="bottom start" @click.stop>
    <template #activator="{ props: menuProps }">
      <v-btn
        v-bind="menuProps"
        icon="mdi-plus"
        size="x-small"
        variant="text"
        density="compact"
        class="tag-picker__btn"
        @click.stop />
    </template>
    <v-card min-width="220" class="tag-picker__menu">
      <v-card-text class="pa-2">
        <div v-for="def in tagDefs" :key="def.key" class="tag-picker__item" @click.stop>
          <v-checkbox
            :model-value="currentTags.includes(def.key)"
            :label="def.label + (def.auto ? ' (auto)' : '')"
            :disabled="def.auto"
            density="compact"
            hide-details
            class="tag-picker__checkbox"
            @update:model-value="(checked) => onToggle(def.key, checked)" />
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  tags: { type: Array, default: () => [] },
  tagDefs: { type: Array, default: () => [] },
});

const emit = defineEmits(["update:tags"]);

const currentTags = computed(() => props.tags || []);

function onToggle(key, checked) {
  const userTags = currentTags.value.filter((t) => {
    const def = props.tagDefs.find((d) => d.key === t);
    return def && !def.auto;
  });
  let updated;
  if (checked) {
    updated = [...userTags, key];
  } else {
    updated = userTags.filter((t) => t !== key);
  }
  emit("update:tags", updated);
}
</script>

<style lang="scss" scoped>
.tag-picker__btn {
  opacity: 0.5;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
}

.tag-picker__menu {
  max-height: 320px;
  overflow-y: auto;
}

.tag-picker__item {
  padding: 0 4px;
}

.tag-picker__checkbox {
  :deep(.v-label) {
    font-size: 13px;
  }
}
</style>
